import * as React from 'react';
export const monduSvg = React.forwardRef(function monduSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.983 0C3.39 0 0 3.374 0 7.985 0 12.595 3.39 16 7.983 16S16 12.626 16 7.985C16 3.343 12.61 0 7.983 0Zm3.968 9.49a1.717 1.717 0 0 1-1.233 1.602L4.247 13.16a.154.154 0 0 1-.193-.097.167.167 0 0 1-.007-.046V6.506a1.714 1.714 0 0 1 1.234-1.602l6.472-2.066a.154.154 0 0 1 .193.097c.004.015.007.03.007.046v6.51l-.002-.001Z',
    }),
  );
});
monduSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mondu = {
  category: 'paymentmethod',
  colorable: true,
  name: 'mondu',
  svg: monduSvg,
};
